/**
 * PopupListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  // Table,
  ModalLayout,
  InputFormTable,
  HtmlContent,
  Text,
} from 'components';
import {
  Button,
  Input,
  Radio,
  Switch,
  Spin,
  Table,
  Upload,
  Tag,
  Flex,
  DatePicker,
} from 'antd';
import moment from 'moment';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { downloadXlsx } from 'utils/XlsxDownloader';

const INITIAL_VALUE = {
  popup_type: null,
  is_show: null,
  popup_name: '',
  popup_date: ['', ''],
};

/**----------------------------------------
 * [Component] 총관리자 > 사이트관리 > 팝업관리: 프레젠터
 * ----------------------------------------
 */
const PopupListPresenter = ({
  loading,
  data,
  onDelete,
  isOpened,
  modalData,
  modalType,
  handleOpenModal,
  setIsOpened,
  setFiles,
  onSave,
  formData,
  setFormData,
  setLoading,
  files,
  // setModalData,
  // setModalType,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [filterList, setFilterList] = React.useState([...data]);
  const [filterItem, setFilterItem] = React.useState(INITIAL_VALUE);

  const beforeUpload = (file) => {
    setFiles(file);
    // return new Promise((resolve, reject) => {
    //   const reader = new FileReader();

    //   // 파일을 ArrayBuffer로 읽기
    //   reader.readAsArrayBuffer(file);

    //   // 파일 읽기가 완료되었을 때 실행
    //   reader.onload = () => {
    //     const buffer = reader.result;
    //     // console.log('파일 버퍼:', buffer);
    //     // 파일 버퍼 데이터를 사용할 수 있음
    //     setFiles([file, buffer]);
    //     resolve(); // 업로드 허용
    //   };

    //   // 파일 읽기 오류 처리
    //   reader.onerror = (error) => {
    //     // message.error('파일을 읽는 중 오류가 발생했습니다.');
    //     reject(error); // 업로드 중단
    //   };
    // });
  };

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    // {
    //   label: '팝업 종류',
    //   form: [
    //     {
    //       input: (
    //         <Radio.Group
    //           value={filterItem.popup_type}
    //           onChange={(e) =>
    //             setFilterItem((prev) => ({
    //               ...prev,
    //               popup_type: e.target.value,
    //             }))
    //           }
    //         >
    //           <Radio value={null}>전체</Radio>
    //           <Radio value={'PC'}>PC</Radio>
    //           <Radio value={'MOBILE'}>모바일</Radio>
    //         </Radio.Group>
    //       ),
    //     },
    //   ],
    // },
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.is_show}
              onChange={(e) =>
                setFilterItem((prev) => ({
                  ...prev,
                  is_show: e.target.value,
                }))
              }
            >
              <Radio value={null}>전체</Radio>
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <>
              <Input
                value={filterItem.popup_name}
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 400 }}
                onChange={(e) =>
                  setFilterItem((prev) => ({
                    ...prev,
                    popup_name: e.target.value,
                  }))
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '노출기간',
      form: [
        {
          input: (
            <Flex align="center" gap={4}>
              <DatePicker
                value={filterItem.start_date}
                placeholder="노출시작일"
                onChange={(date) =>
                  setFilterItem((prev) => ({
                    ...prev,
                    start_date: date,
                  }))
                }
              />
              <p>~</p>
              <DatePicker
                value={filterItem.end_date}
                placeholder="노출종료일"
                onChange={(date) =>
                  setFilterItem((prev) => ({
                    ...prev,
                    end_date: date,
                  }))
                }
              />
            </Flex>
          ),
        },
      ],
    },
  ];

  const form = [
    {
      label: '제목',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              value={formData.popup_name}
              onChange={(e) =>
                setFormData((p) => ({ ...p, popup_name: e.target.value }))
              }
              placeholder="새 팝업의 제목을 입력해주세요"
              style={{ ...styles.form.input.large, width: 500 }}
              maxLength={50}
              showCount
            />
          ),
        },
      ],
    },
    {
      label: '내용',
      required: true,
      form: [
        {
          // input: <div style={{ height: 430 }}>에디터!!!!</div>,
          input: (
            <div style={{ maxHeight: 430, overflowY: 'auto', width: '100%' }}>
              {formData?.popup_content ? null : (
                <Upload
                  // onChange={handleFile}
                  // onRemove={(_file) => setUploadData(null)}
                  beforeUpload={(info) => {
                    // setFiles([info]);
                    beforeUpload(info);
                    return false;
                  }}
                  block
                  maxCount={1}
                  fileList={
                    !files
                      ? []
                      : [
                          {
                            uid: 1,
                            name: files.name,
                            status: 'done',
                            url: URL.createObjectURL(files),
                          },
                        ]
                  }
                  listType="picture"
                  accept="image/*"
                >
                  <Button icon={<UploadOutlined />}>
                    팝업 이미지를 업로드해주세요
                  </Button>
                </Upload>
              )}

              {formData?.popup_content ? (
                <div style={{ position: 'relative', top: 0, left: 0 }}>
                  <HtmlContent
                    content={formData?.popup_content}
                    style={{ marginTop: 10 }}
                  />

                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() =>
                      setFormData((p) => ({ ...p, popup_content: null }))
                    }
                    style={{ position: 'absolute', top: -16, right: -16 }}
                  />
                </div>
              ) : null}
            </div>
          ),
        },
      ],
    },
    // {
    //   label: '크기',
    //   form: [
    //     {
    //       input: (
    //         <>
    //           <p style={{ ...styles.form.text, padding: '0px 2px' }}>너비</p>
    //           <Input
    //             size="large"
    //             placeholder="400"
    //             style={{ ...styles.form.input.medium }}
    //           />
    //           <p style={{ ...styles.form.text, padding: '0px 2px' }}>px</p>
    //         </>
    //       ),
    //     },
    //     {
    //       input: (
    //         <>
    //           <p style={{ ...styles.form.text, padding: '0px 2px' }}>/</p>
    //         </>
    //       ),
    //     },
    //     {
    //       input: (
    //         <>
    //           <p style={{ ...styles.form.text, padding: '0px 2px' }}>높이</p>
    //           <Input
    //             size="large"
    //             placeholder="500"
    //             style={{ ...styles.form.input.medium }}
    //           />
    //           <p style={{ ...styles.form.text, padding: '0px 2px' }}>px / </p>
    //         </>
    //       ),
    //     },
    //   ],
    // },

    {
      label: '노출기간',
      required: true,
      form: [
        {
          input: (
            <Flex align="center" gap={4}>
              <DatePicker
                size="large"
                value={
                  formData?.popup_start_date
                    ? dayjs.unix(formData?.popup_start_date)
                    : ''
                }
                onChange={(date) =>
                  setFormData((p) => ({
                    ...p,
                    popup_start_date: dayjs(date).unix(),
                  }))
                }
                placeholder="시작일"
                showTime
                showHour
                showMinute
                maxDate={
                  formData?.popup_end_date
                    ? dayjs.unix(formData?.popup_end_date)
                    : ''
                }
              />
              <p>~</p>
              <DatePicker
                size="large"
                value={
                  formData?.popup_end_date
                    ? dayjs.unix(formData?.popup_end_date)
                    : ''
                }
                onChange={(date) =>
                  setFormData((p) => ({
                    ...p,
                    popup_end_date: dayjs(date).unix(),
                  }))
                }
                placeholder="종료일"
                showTime
                showHour
                showMinute
                minDate={dayjs.unix(formData?.popup_start_date)}
              />
            </Flex>
          ),
        },
      ],
    },

    {
      label: 'URL',
      form: [
        {
          input: (
            <Input
              size="large"
              value={formData.render_url}
              onChange={(e) =>
                setFormData((p) => ({ ...p, render_url: e.target.value }))
              }
              placeholder="http 또는 https를 포함한 전체 URL을 입력해주세요."
              style={{ ...styles.form.input.large, width: 500 }}
              maxLength={255}
              showCount
            />
          ),
        },
      ],
    },
    {
      label: '새 창 여부',
      form: [
        {
          input: (
            <Radio.Group
              value={formData.is_new_window}
              onChange={(e) =>
                setFormData((p) => ({ ...p, is_new_window: e.target.value }))
              }
            >
              <Radio value={'Y'}>Y</Radio>
              <Radio value={'N'}>N</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  const col = [
    {
      title: 'No',
      key: 'popup_id',
      dataIndex: 'popup_id',
      sorter: (a, b) => a.popup_id - b.popup_id,
    },
    {
      title: '팝업 종류',
      key: 'popup_type',
      dataIndex: 'popup_type',
      width: 100,
      render: (value) => <Tag>{value}</Tag>,
    },
    {
      title: '제목',
      key: 'popup_name',
      dataIndex: 'popup_name',
      width: 500,
      // align: 'left',
      render: (value, row) => (
        <Flex align="center" gap={24}>
          <HtmlContent content={row.popup_content} style={{ width: 80 }} />

          <Text size={14}>{value}</Text>
        </Flex>
      ),
    },
    {
      title: '노출 시작일',
      key: 'popup_start_date',
      dataIndex: 'popup_start_date',
      render: (text) => dayjs.unix(text).format('YYYY-MM-DD(HH:mm:ss)'),
    },
    {
      title: '노출 종료일',
      key: 'popup_end_date',
      dataIndex: 'popup_end_date',
      render: (text) => dayjs.unix(text).format('YYYY-MM-DD(HH:mm:ss)'),
    },
    {
      title: '노출여부',
      key: 'is_show',
      dataIndex: 'is_show',
      width: 100,
      render: (value) => (
        <Tag color={value === 'Y' ? 'processing' : 'default'}>
          {value === 'Y' ? '노출' : '숨김'}
        </Tag>
      ),
      filters: [
        {
          text: '노출',
          value: 'Y',
        },
        {
          text: '숨김',
          value: 'ㅜ',
        },
      ],
      onFilter: (value, { is_show }) => is_show === value,
    },
    {
      title: '랜딩 URL',
      key: 'render_url',
      dataIndex: 'render_url',
      render: (value) => (value ? <Button type="link">{value}</Button> : '-'),
      width: 250,
    },
    {
      title: '새창여부',
      key: 'is_new_window',
      width: 100,
      dataIndex: 'is_new_window',
      filters: [
        {
          text: '새창',
          value: 'Y',
        },
        {
          text: '현재창',
          value: 'N',
        },
      ],
      onFilter: (value, { is_new_window }) => is_new_window === value,
    },
    // {
    //   title: '노출순서',
    //   key: 'order',
    //   dataIndex: 'order',
    // },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 팝업 조건 검색
   * --
   * @param {string} t
   */
  const handleSearch = (t) => {
    setLoading(true);
    const searchType = t.toLocaleUpperCase();

    let arr = [...data];
    switch (searchType) {
      case 'RESET':
        setFilterItem(INITIAL_VALUE);
        break;
      case 'SEARCH':
        const { popup_name, is_show, popup_type, start_date, end_date } =
          filterItem;

        if (is_show) {
          arr = arr.filter((popup) => popup.is_show === is_show);
        }

        if (popup_type) {
          arr = arr.filter((popup) => popup.popup_type === popup_type);
        }

        if (popup_name) {
          arr = arr.filter((popup) => popup.popup_name.includes(popup_name));
        }

        if (start_date || end_date) {
          const filterType =
            start_date && end_date ? 'BETWEEN' : start_date ? 'START' : 'END';

          switch (filterType) {
            case 'START':
              arr = arr.filter(
                (popup) =>
                  popup.popup_start_date >= dayjs(start_date).startOf().unix()
              );
              break;
            case 'END':
              arr = arr.filter(
                (popup) =>
                  popup.popup_end_date <= dayjs(end_date).endOf('day').unix() ||
                  popup.popup_start_date <= dayjs(end_date).endOf('day').unix()
              );
              break;
            case 'BETWEEN':
              arr = arr.filter(
                (popup) =>
                  popup.popup_start_date >=
                    dayjs(start_date).startOf().unix() ||
                  popup.popup_end_date <= dayjs(end_date).endOf('day').unix()
              );
              break;
            default:
              break;
          }
        }

        break;
      default:
        break;
    }

    setTimeout(() => {
      setLoading(false);
      setFilterList(arr);
    }, 1000);
  };

  /* ===== HOOKS ===== */
  React.useEffect(() => {
    setFilterList(data);
  }, [data]);

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={loading}>
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          <Title size={3} style={{ marginBottom: 14 }}>
            팝업 관리
          </Title>
          <Row>
            <Col x={24}>
              {/* 검색필터 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'none'}
                style={{ marginBottom: 20 }}
              >
                <ExpandableContainer borderRadius={4} padding={20}>
                  {formItem.map((_item, _index) => (
                    <div
                      key={`form_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      <div
                        style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                      >
                        <label>{_item.label}</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {_item.form.map((_subitem, _subkey) => (
                          <React.Fragment key={`input_${_subkey}`}>
                            {_subitem.input}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}
                </ExpandableContainer>

                {/* 검색/초기화 버튼 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: 20,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() => handleSearch('search')}
                  >
                    검색
                  </Button>
                  <Button
                    size="large"
                    style={{ ...styles.button }}
                    onClick={() => handleSearch('reset')}
                  >
                    초기화
                  </Button>
                </div>
                {/* 검색/초기화 버튼 끝 */}
              </Content>
              {/* 검색필터 끝 */}

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                  }}
                >
                  <h4
                    style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                  >
                    총 <span>{filterList.length}</span>개
                  </h4>
                  <Button
                    size="large"
                    style={{ marginRight: 8 }}
                    onClick={() => handleOpenModal('create')}
                  >
                    새 팝업
                  </Button>
                  <Button
                    style={{ marginRight: 8 }}
                    size="large"
                    onClick={() =>
                      downloadXlsx({
                        columns: col,
                        rows: filterList?.map((_item) => ({
                          ..._item,
                          popup_type:
                            _item?.popup_type === 'ALL'
                              ? '전체'
                              : _item?.popup_type === 'PC'
                              ? '웹'
                              : '모바일',
                        })),
                        fileName: '팝업',
                      })
                    }
                  >
                    엑셀로 다운로드
                  </Button>
                </div>
                {/* {console.log('data ==>', data)}
                {console.log('filterList ==>', filterList)} */}
                <Table
                  dataSource={filterList ?? []}
                  // isChecked
                  columns={col}
                  scroll={{ x: 'max-content' }}
                  onRow={(record) => {
                    return {
                      onClick: () => handleOpenModal('DETAIL', record),
                    };
                  }}
                />
              </Content>
              {/* 검색결과 끝 */}
            </Col>
          </Row>
        </Content>
      </Spin>

      <ModalLayout
        type={'modal'}
        open={isOpened}
        onCancel={setIsOpened}
        centered
        closable
        title={
          modalType === 'CREATE'
            ? '새 팝업'
            : modalType === 'UPDATE'
            ? '팝업 수정'
            : '팝업 상세보기'
        }
        width={798}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={8} style={{ textAlign: 'left', display: 'flex' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {modalType === 'DETAIL' && (
                    <Button
                      onClick={() => {
                        handleOpenModal('UPDATE', modalData);
                        setFormData(modalData);
                      }}
                    >
                      편집
                    </Button>
                  )}
                  <p
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      lineHeight: '133%',
                      paddingRight: 5,
                      marginLeft: 13,
                    }}
                  >
                    노출여부
                  </p>
                  <Switch
                    checked={formData.is_show === 'Y' ? true : false}
                    onChange={(e) => setFormData('is_show', e ? 'Y' : 'N')}
                  />
                </div>
              </Col>
              <Col x={8} style={{ textAlign: 'center' }}></Col>
              <Col x={8}>
                {modalType === 'DETAIL' ? (
                  <>
                    <Button
                      color="danger"
                      variant="filled"
                      onClick={() => onDelete(modalData?.popup_id)}
                    >
                      삭제
                    </Button>
                  </>
                ) : (
                  <>
                    <Button type="primary" onClick={onSave}>
                      저장
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              {(() => {
                // console.log('modalData: ', modalData);
              })()}
              {modalType === 'DETAIL' ? (
                <div>
                  <div style={{ borderBottom: '1px solid #F4F4F5' }}>
                    <h4
                      style={{
                        fontSize: 23,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      {modalData?.popup_name}
                    </h4>
                    <div
                      style={{
                        display: 'flex',
                        fontSize: 12,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      <p>
                        작성일:{' '}
                        <span style={{ color: '#8A8A8A' }}>
                          {moment(modalData?.created_at * 1000).format(
                            'YYYY-MM-DD (HH:mm:ss)'
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    style={{ height: 500, overflow: 'auto', padding: '16px 0' }}
                  >
                    <HtmlContent content={modalData?.popup_content} />
                  </div>
                </div>
              ) : (
                <InputFormTable form={form} labelWidth={148} />
              )}
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default PopupListPresenter;
